import BaseScreen from './_base';

export default function SummariesScreen() {
  return <BaseScreen title="Summaries" description="Summary analytics dashboard." />;
}
